import { CurrencyText } from 'components/text/decimal/CurrencyText';
import { DecimalTextProps } from 'components/text/decimal/DecimalText';
import { ProgressText, type ProgressTextProps } from 'components/text/progress/ProgressText';

type CurrencyProgressTextProps = {
    value: number;
    target?: number | null;
    size?: DecimalTextProps['size'];
} & Omit<ProgressTextProps, 'value'>;

export function CurrencyProgressText({ value, target, size, ...rest }: CurrencyProgressTextProps) {
    return (
        <ProgressText
            value={<CurrencyText value={value} size={size} />}
            target={target ? <CurrencyText value={target} size="xs" color="text.disabled" /> : undefined}
            {...rest}
        />
    );
}
